import script from "./campaign-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./campaign-preview.vue?vue&type=script&setup=true&lang=js"

import "./campaign-preview.vue?vue&type=style&index=0&id=3c419ade&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c419ade"]])

export default __exports__